<template>
    <div class="bg-white dark:bg-gray-800 shadow rounded-lg">
        <div class="px-4 py-5 sm:p-6">
            <h3
                class="text-lg leading-6 font-medium text-gray-900 dark:text-white mb-4"
            >
                User Distribution
            </h3>
            <div class="space-y-3">
                <div
                    v-for="item in distribution"
                    :key="item.role"
                    class="flex items-center justify-between"
                >
                    <div class="flex items-center">
                        <div
                            :class="[
                                'w-3 h-3 rounded-full mr-3',
                                `bg-${item.color}-500`,
                            ]"
                        ></div>
                        <span
                            class="text-sm font-medium text-gray-900 dark:text-white"
                        >
                            {{ item.role }}
                        </span>
                    </div>
                    <div class="flex items-center">
                        <span
                            class="text-sm text-gray-500 dark:text-gray-400 mr-3"
                        >
                            {{ item.count }} users
                        </span>
                        <span
                            class="text-sm font-medium text-gray-900 dark:text-white"
                        >
                            {{ item.percentage }}%
                        </span>
                    </div>
                </div>
            </div>

            <!-- Simple bar visualization -->
            <div class="mt-4 space-y-2">
                <div
                    v-for="item in distribution"
                    :key="`bar-${item.role}`"
                    class="relative"
                >
                    <div
                        class="flex items-center text-xs text-gray-500 dark:text-gray-400 mb-1"
                    >
                        <span>{{ item.role }}</span>
                    </div>
                    <div
                        class="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2"
                    >
                        <div
                            :class="[
                                'h-2 rounded-full transition-all duration-300',
                                `bg-${item.color}-500`,
                            ]"
                            :style="{ width: `${item.percentage}%` }"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { UserDistribution } from "@/types/dashboard";

interface Props {
    distribution: UserDistribution[];
}

defineProps<Props>();
</script>
